"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function CTPModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util) {
	var self = this;

	/** Google Tag Manager data **/
	this.gtmTransactionAffiliation = 'payments';
}
